import styled from 'styled-components';
import DataGrid, { DataGridCell } from 'components/DataGrid';
import { CalciteInput, CalciteSelect } from 'components/Calcite';

export const StyledTable = styled(DataGrid)`
  table-layout: fixed;
`;

export const StyledCheckboxHeaderCell = styled(DataGridCell)`
  width: 45px;
`;

export const SchemaCell = styled(DataGridCell)`
  height: 45px;
  box-sizing: border-box;
`;

export const CheckboxCell = styled(SchemaCell)`
  width: 45px;
  text-align: center;
`;

export const FieldTypeCell = styled(SchemaCell)`
  min-width: 150px;
  padding: 0;
`;

export const StyledCalciteSelect = styled(CalciteSelect)`
  --calcite-color-border-input: ${({ theme }) => theme.color.foreground1};
`;

export const FieldNameCell = styled(SchemaCell)`
  min-width: 200px;
  padding: 0 0.75em 0.2em 0.5em;
  display: flex;
  align-items: flex-end;
`;

export const StyledMapperTableTextField = styled(CalciteInput)`
  --calcite-color-border-input: ${({ theme }) => theme.color.foreground1};
  border-bottom: 1px solid ${({ theme }) => theme.color.border2};
  flex: 1;
  min-width: 0; // Prevents error icon from getting pushed out of table cell
`;

export const SampleCell = styled(SchemaCell)`
  background-color: ${({ theme }) => theme.color.foreground1};
  font-family: ${({ theme }) => theme.font.codeFamily};
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow-x: hidden;
  border-left: 1px solid ${({ theme }) => theme.color.border1};
`;
